import Markdown from './Markdown'
import Table from './Table'
import BulletedList from './BulletedList'
import CodeBlock from './CodeBlock'
import Heading from './Heading'
import Blockquote from './Blockquote'
import CalloutBlock from './CalloutBlock'
import ChecklistBlock from './ChecklistBlock'
import JSONBlock from './JSONBlock'
import CardBlock from './CardBlock'
import AppConnectionCardBlock from './AppConnectionCardBlock'
import FileArtifactBlock from './FileArtifactBlock'
import DividerBlock from './DividerBlock'
import MediaBlock from './MediaBlock'
import ToolBlock from './ToolBlock'
import AgentQuestionBlock from './AgentQuestionBlock'
import AIResponseLog from './AIResponseLog'
import SelectionSwitchCard from './SelectionSwitchCard'
import CreatedTriggerCard from './CreatedTriggerCard'
import { phase1BlockRegistryEntries } from './phase1BlockRegistryEntries'

export const chatResponseBlockRegistry = {
  text: ({ block, i, streaming }) => (
    <Markdown key={i} variant={block.variant ?? 'default'} streaming={streaming}>
      {block.content}
    </Markdown>
  ),
  markdown: ({ block, i, streaming }) => (
    <Markdown key={i} variant={block.variant ?? 'default'} streaming={streaming}>
      {block.content}
    </Markdown>
  ),
  heading: ({ block, i, streaming }) => (
    <Heading key={i} level={block.level} streaming={streaming}>
      {block.content}
    </Heading>
  ),
  list: ({ block, i, streaming }) => (
    <BulletedList key={i} items={block.items} streaming={streaming} variant={block.variant} />
  ),
  code: ({ block, i }) => <CodeBlock key={i} language={block.language} code={block.content} />,
  table: ({ block, i }) => <Table key={i} data={block.data} />,
  quote: ({ block, i }) => <Blockquote key={i}>{block.content}</Blockquote>,
  callout: ({ block, i }) => (
    <CalloutBlock key={i} type={block.style || 'info'} content={block.content} />
  ),
  checklist: ({ block, i }) => <ChecklistBlock key={i} items={block.items} />,
  json: ({ block, i }) => <JSONBlock key={i} data={block.data} title={block.title} />,
  card: ({ block, i }) => (
    <CardBlock key={i} title={block.title} subtitle={block.subtitle} content={block.content} />
  ),
  appConnection: ({ block, i }) => (
    <AppConnectionCardBlock
      key={i}
      title={block.title}
      description={block.description}
      iconUrl={block.iconUrl}
      status={block.status}
      tags={block.tags}
      successBullets={block.successBullets}
      successClosing={block.successClosing}
      toolkitSlug={block.toolkitSlug}
    />
  ),
  fileArtifact: ({ block, i }) => (
    <FileArtifactBlock
      key={i}
      fileName={block.fileName}
      description={block.description}
      artifactKind={block.artifactKind}
      artifactId={block.artifactId}
    />
  ),
  divider: ({ i }) => <DividerBlock key={i} />,
  media: ({ block, i }) => (
    <MediaBlock key={i} type={block.mediaType} url={block.url} alt={block.alt} caption={block.caption} />
  ),
  tool: ({ block, i }) => (
    <ToolBlock key={i} toolName={block.toolName} status={block.status} result={block.result} />
  ),
  aiResponseLog: ({ block, i, streaming }) => (
    <AIResponseLog
      key={i}
      status={block.status}
      steps={block.steps ?? []}
      showLogStatus={Boolean(block.showLogStatus)}
      streaming={streaming}
    />
  ),
  agentQuestion: ({ block, i, onAgentQuestionSelect }) => (
    <AgentQuestionBlock
      key={i}
      prompt={block.prompt}
      options={block.options}
      status={block.status}
      agentBrand={block.agentBrand}
      agentName={block.agentName}
      onSelect={onAgentQuestionSelect}
    />
  ),
  selectionSwitch: ({ block, i }) => (
    <SelectionSwitchCard
      key={i}
      switchKind={block.switchKind}
      fromLabel={block.fromLabel}
      toLabel={block.toLabel}
    />
  ),
  createdTrigger: ({ block, i }) => (
    <CreatedTriggerCard
      key={i}
      title={block.title}
      schedule={block.schedule}
      label={block.label}
    />
  ),
  ...phase1BlockRegistryEntries,
}
